import styled from 'styled-components'

import { BoxDetails as BoxDetailsBase } from '@application/Interfaces/Molecules'
import { TitleSection as TitleSectionBase } from '@organisms/TitleSection'

export const TitleSection = styled(TitleSectionBase)`
    padding-bottom: 50px;
    background-color: ${(props) => (props.mode === 'Dark' ? props.theme.color.p600 : props.theme.color.g100)};
`

export const BoxDetails = styled(BoxDetailsBase)`
    max-width: 970px;
    margin: 0 auto;
`

export const VolumeWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    align-items: flex-end;
    border-radius: 7px;
    ${(props) => props.theme.boxShadow.level1};
    border: 1px solid ${(props) => props.theme.color.p500};
    background-color: ${(props) => props.theme.color.white};
`

export const VolumeLabel = styled.div`
    ${(props) => props.theme.typo.bodyS}
    ${(props) => props.theme.fontWeight.regular}
    color: ${(props) => props.theme.color.p600};
    line-height: 180%;
`

export const VolumeValueWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
`

export const VolumeValue = styled.div`
    ${(props) => props.theme.typo.bodyL}
    ${(props) => props.theme.fontWeight.bold}
    color: ${(props) => props.theme.color.p500};
    line-height: 180%;
    overflow-wrap: anywhere;
`

export const VolumeUnit = styled.div`
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.medium}
    color: ${(props) => props.theme.color.p500};
    padding-left: 8px;
`
